import { getDarkerColor, getLighterColor } from "./base";

const PRIMARY_COLOR = "#FFDE02";
const PRIMARY_CONTRAST_COLOR = "#FFFFFF";

const SECONDARY_COLOR = "#070E20";
const SECONDARY_CONTRAST_COLOR = "#E1EBE5";

const TERTIARY_COLOR = "#47667B";
const TERTIARY_CONTRAST_COLOR = "#F5F5F5";

const BRAND_ACCENT = "#FFDE02";
const HIGHLIGHT = "255 221 2"; //rgb format

const exness = {
  brand: BRAND_ACCENT,
  highlight: HIGHLIGHT,
  primary: {
    bg: PRIMARY_COLOR, // Primary background color
    DEFAULT: PRIMARY_COLOR, // Default primary color,
    text: PRIMARY_CONTRAST_COLOR, // Primary contrast color,
    hover: getLighterColor(PRIMARY_COLOR, 0.8),
    lighter: getLighterColor(PRIMARY_COLOR, 0.05),
    darker: getDarkerColor(PRIMARY_COLOR, 0.1)
  },
  secondary: {
    DEFAULT: SECONDARY_COLOR,
    bg: SECONDARY_COLOR,
    text: SECONDARY_CONTRAST_COLOR,
    hover: getLighterColor(SECONDARY_COLOR, 0.8)
  },
  tertiary: {
    DEFAULT: TERTIARY_COLOR,
    bg: TERTIARY_COLOR,
    text: TERTIARY_CONTRAST_COLOR,
    hover: getLighterColor(TERTIARY_COLOR, 0.8)
  },
  map: {
    availableColor: SECONDARY_COLOR,
    notAvailableColor: "rgba(169, 169, 169, 1)",
    spotNotBookeableUnavailableStroke: "rgba(153, 95, 95, 0.46)",
    spotNotBookeableUnavailableFill: "rgba(232, 236, 239, 1)",
    spotNotBookeableStroke: "rgba(255, 255, 255, 1)",
    spotNotBookeableFill: "#FBAF57",
    spotRequiresApprovalStroke: "rgba(255, 255, 255, 1)",
    spotRequiresApprovalFill: "#E8ECEF",
    spotBookeableWithSchedulesStroke: "rgba(255, 255, 255, 1)",
    spotFullyAvailableStroke: "rgba(255, 255, 255, 1)",
    spotNotAssignedFill: "rgba(232, 236, 239, 1)"
  }
};

export default exness;
